import { AcademyDoc } from '@/features/home/types';
import { getAcademy } from '@/libs/firebase/firestore';

export const fetchAcademyById = async (academyId: string) => {
  return await getAcademy<AcademyDoc>(academyId);
};
